const cards = [
  {
    id: 1,
    img: "/Img/abriss-rtlwest-work.png",
    work: "SCHNITT",
    title: "Hauserweiterung - RTLWEST",
    type: "NEWS",
    preview: "",
    video: "",
    link: "https://www.instagram.com/reels/DVJKvDnjWt7/",
    place: "Ausbildung",
    description: "",
  },
  {
    id: 2,
    img: "/Img/airbus-rtlwest-work.png",
    work: "SCHNITT",
    title: "Feuerübung - RTLWEST",
    type: "NEWS",
    preview: "",
    video: "",
    link: "https://www.instagram.com/reels/DNOch9sNmrx/",
    place: "Ausbildung",
    description: "",
  },
  {
    id: 3,
    img: "/Img/stinktier-rtlwest-work.png",
    work: "SCHNITT",
    title: "Stinktiere - RTLWEST",
    type: "NEWS",
    preview: "",
    video: "",
    link: "https://www.instagram.com/reels/DOLy6_PFent/",
    place: "Ausbildung",
    description: "",
  },
  {
    id: 4,
    img: "/Img/tillyKunst-rtlwest-work.png",
    work: "SCHNITT",
    title: "Tilly's Kunst - RTLWEST",
    type: "NEWS",
    preview: "",
    video: "",
    link: "https://www.instagram.com/reels/DU3m5nGgBhJ/",
    place: "Ausbildung",
    description: "",
  },
  {
    id: 5,
    img: "/Img/run-work.png",
    work: "KAMERA & SCHNITT",
    title: "Sponsorenlauf Wuppertal",
    type: "WERBEVIDEO",
    preview: "",
    video: "",
    link: "https://www.instagram.com/p/ChCpD2lgXLS/",
    place: "Arbeit",
    description: "",
  },
  {
    id: 6,
    img: "/Img/KleinstadtFreunde-work.jpg",
    work: "REGIE, KAMERA & SCHNITT",
    title: "KleinstadtFreunde",
    type: "MUSIK EVENT",
    preview: "",
    video: "",
    link: "https://www.instagram.com/kleinstadt_freunde/",
    place: "Arbeit",
    description: "",
  },
  {
    id: 7,
    img: "/Img/corona-work.png",
    work: "REGIE & KAMERA",
    title: "Corona Erklärvideo",
    type: "IMAGEFILM",
    preview:
      "https://cloud.rezepoge.de/s/ePtMdgBtrspLDCf/download/Erkl%C3%A4rvideo%20Corona%20_%20D%C3%BCren%20Powervolleys%20_%202020%20-%20Preview.mp4",
    video:
      "https://cloud.rezepoge.de/s/HFka2F9FjGQHdKQ/download/Erkl%C3%A4rvideo%20Corona%20_%20D%C3%BCren%20Powervolleys%20_%202020.mp4",
    link: "https://www.youtube.com/watch?v=E00uixYbv2w",
    place: "Arbeit",
    description: "",
  },
  {
    id: 8,
    img: "/Img/praktikum-work.png",
    work: "REGIE, KAMERA & SCHNITT",
    title: "LoL WM Trailer",
    type: "TRAILER",
    preview:
      "https://cloud.rezepoge.de/s/BArxggMzB93kxxA/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29%20-%20Preview.mp4",
    video:
      "https://cloud.rezepoge.de/s/F52fBDDCNnGbz3s/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29.mp4",
    link: "https://www.youtube.com/watch?v=-u0NQpcs3ww",
    place: "Praktikumsaufgabe",
    description: "",
  },
  {
    id: 9,
    img: "https://i.ytimg.com/vi/z7OULAfaZTU/hqdefault.jpg",
    work: "REGIE, KAMERA & SCHNITT",
    title: "FC Mettmann 08",
    type: "SPORT",
    preview: "",
    video: "",
    link: "https://www.youtube.com/@fcmettmann0882",
    place: "Freizeit",
    description: "",
  },
  {
    id: 10,
    img: "https://i.ytimg.com/vi/FWhSw4ppW4s/hqdefault.jpg",
    work: "REGIE & SCHNITT",
    title: "Lightsaber Fanmade",
    type: "CHOREOGRAPHIE",
    preview:
      "https://cloud.rezepoge.de/s/nYHrqCKCo8f7bF8/download/laserschwert%20-%20Preview.mp4",
    video:
      "https://cloud.rezepoge.de/s/48SrDKc6pdyxQzc/download/Lightsaber%20Fanmade.mp4",
    link: "https://www.youtube.com/watch?v=FWhSw4ppW4s",
    place: "Freizeit",
    description: "",
  },
  {
    id: 11,
    img: "/Img/lol-work.png",
    work: "REGIE & SCHNITT",
    title: "LoL WM Aftermovie",
    type: "EDIT",
    preview:
      "https://cloud.rezepoge.de/s/BArxggMzB93kxxA/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29%20-%20Preview.mp4",
    video:
      "https://cloud.rezepoge.de/s/F52fBDDCNnGbz3s/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29.mp4",
    link: "https://www.youtube.com/watch?v=yBNSSvHrjOE",
    place: "Praktikum",
    description: "",
  },
  {
    id: 12,
    img: "https://i.ytimg.com/vi/mk6Nr0Jd3Lk/hqdefault.jpg",
    work: "KAMERA",
    title: "Pünktlich - SCJ",
    type: "MUSIKVIDEO",
    preview:
      "https://cloud.rezepoge.de/s/BArxggMzB93kxxA/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29%20-%20Preview.mp4",
    video:
      "https://cloud.rezepoge.de/s/F52fBDDCNnGbz3s/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29.mp4",
    link: "https://www.youtube.com/watch?v=mk6Nr0Jd3Lk",
    place: "Freizeit",
    description: "",
  },
  {
    id: 13,
    img: "https://i.ytimg.com/vi/c9rI6t1nEvw/hqdefault.jpg",
    work: "KAMERA",
    title: "Schwerelos - SCJ",
    type: "MUSIKVIDEO",
    preview:
      "https://cloud.rezepoge.de/s/BArxggMzB93kxxA/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29%20-%20Preview.mp4",
    video:
      "https://cloud.rezepoge.de/s/F52fBDDCNnGbz3s/download/SCJ%20-%2015%2016%2017%20%28Official%20Video%29.mp4",
    link: "https://www.youtube.com/watch?v=c9rI6t1nEvw",
    place: "Freizeit",
    description: "",
  },
];

export default cards;
